export default {
  GET_DoctorUsers: [],
};
